export default {
  title: 'Impressum',
  subtitle: 'Personaliza los detalles que aparecen en el Impressum de tu tienda sin modificar tu perfil empresarial.',
  defaultsNotice:
    'Todos los campos son opcionales. Deja uno vacío para seguir usando el valor de tu perfil empresarial; el predeterminado actual aparece en gris como vista previa. Rellenar un campo solo afecta al Impressum; tu perfil empresarial no cambia.',
  fields: {
    legal_name: {
      label: 'Empresa / nombre legal',
      placeholder: 'p. ej. Musterbetrieb GmbH',
    },
    owner_first_name: {
      label: 'Nombre del propietario',
      placeholder: 'p. ej. Alex',
    },
    owner_last_name: {
      label: 'Apellido del propietario',
      placeholder: 'p. ej. Müller',
    },
    owner_email: {
      label: 'Correo electrónico',
      placeholder: 'p. ej. info@example.com',
      invalid: 'Introduce una dirección de correo electrónico válida',
    },
    owner_phone_number: {
      label: 'Teléfono',
      placeholder: 'p. ej. +49 30 1234567',
    },
    tax_id: {
      label: 'NIF/CIF',
      placeholder: 'p. ej. DE123456789',
    },
    address: {
      label: 'Dirección',
      placeholder: 'Calle, código postal, ciudad',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    saved: 'Impressum guardado',
    failed: 'Error al guardar el Impressum',
  },
};
